module.exports = __webpack_public_path__ + "img/secure.e835ef9.svg";